import {
  ComplianceEntity,
  VerificationLaneKind,
  VerificationLaneStatus
} from "@wingspanhq/wingspan-api-sdk";

export type ComplianceEntityTaxVerification =
  | "Verified"
  | "Pending"
  | "Failed"
  | "None";

/**
 * Collapse the v3 per-jurisdiction verification lanes into a single tax
 * verification status for display. v3 reports `verificationStatus.statuses[]`,
 * each with `lanes[]` per verification kind; we look only at the `Tax` lanes
 * and surface the most significant outcome across jurisdictions.
 */
export const selectorComplianceEntityTaxVerification = (
  complianceEntity?: ComplianceEntity
): ComplianceEntityTaxVerification => {
  const taxLaneStatuses = (complianceEntity?.verificationStatus?.statuses ?? [])
    .flatMap(status => status.lanes ?? [])
    .filter(lane => lane.kind === VerificationLaneKind.TAX)
    .map(lane => lane.status);

  if (taxLaneStatuses.includes(VerificationLaneStatus.VERIFIED)) {
    return "Verified";
  }
  if (taxLaneStatuses.includes(VerificationLaneStatus.PENDING)) {
    return "Pending";
  }
  if (taxLaneStatuses.includes(VerificationLaneStatus.FAILED)) {
    return "Failed";
  }
  return "None";
};
